// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-end',
    [theme.breakpoints.down(700)]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  basketTotalContainer: {
    position: 'absolute',
    top: 20,
    right: 20,
    [theme.breakpoints.down(700)]: {
      position: 'relative',
      marginLeft: 25,
    },
  },
  button: {
    marginBottom: 35,
    minWidth: 120,
    [theme.breakpoints.down(700)]: {
      marginBottom: 5,
      minWidth: 150,
    },
  },
  successText: {
    color: GlobalStyles.color.COLOR_GREEN,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    textAlign: 'center',
  },
  rejectedColor: {
    color: GlobalStyles.color.COLOR_REJECT,
  },
});

export default styles;
